export class CompanyServicesModel {
  //companyServiceId: string;
  // companyName: string;
  // image: string;
  // imageFile: any
  // //companyName:string;
  // companyId: string
  // title: string;
  // description: string;
  serviceId: string;
  serviceName: string;
  status: boolean;

  constructor() {
    this.serviceId ="";
    this.serviceName="";
    this.status = false;
  
    // this.companyServiceId = "";
    // this.companyName = "";
    // this.image = "";
    // this.imageFile = null;
    // //this.companyName="";
    // this.companyId = "";
    // this.title = "";
    // this.description = "";
  }
}
